import { Logo } from "./marks/Logo";

export function Footer() {
  return (
    <footer className="footer">
      <div className="shell footer__inner">
        <Logo className="footer__mark" />
        <p className="footer__note">
          Path &amp; Pace — built for the run you actually do.
        </p>
        <p className="footer__legal">© {new Date().getFullYear()} Path &amp; Pace</p>
      </div>
    </footer>
  );
}
